// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"a6adcb6a","787":"89cae223"}[chunkId] + ".chunk.js";
};